/**
 * MyDayCalendarWidget - Виджет "Мой день" с полноценным календарём
 *
 * Показывает календарь с событиями текущего пользователя:
 * - Звонки (где пользователь - caller)
 * - Встречи (где пользователь - участник)
 * - Мастер-классы (где пользователь - sales или manager)
 */
import React from 'react';
import {
  Card,
  Group,
  Title,
} from '@mantine/core';
import { IconCalendar } from '@tabler/icons-react';
import { useSession } from '../../context/SessionContext';
import Calendar from '../Calendar/Calendar';

const MyDayCalendarWidget = () => {
  const { user } = useSession();

  return (
    <Card shadow="sm" radius={16} withBorder p="lg" h="100%">
      {/* Заголовок */}
      <Group gap="xs" mb="md">
        <IconCalendar size={20} color="#0176D3" />
        <Title order={4}>Мой день</Title>
      </Group>

      {/* Календарь с фильтрацией по текущему пользователю */}
      <Calendar userId={user?.id} />
    </Card>
  );
};

export default MyDayCalendarWidget;
